import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import baseTheme, { CONTRAST_MORE, SCHEME_LIGHT } from './theme';
var baseColors = baseTheme.colors;
export default _objectSpread(_objectSpread({}, baseTheme), {}, {
  colors: _objectSpread(_objectSpread({}, baseTheme.colors), {}, {
    SCHEME: SCHEME_LIGHT,
    CONTRAST: CONTRAST_MORE,
    bg: baseColors.bgHCLight,
    bgPlaceholder: baseColors.bgPlaceholderHCLight,
    ctrl: baseColors.ctrlHCLight,
    ctrlBg: baseColors.ctrlBgHCLight,
    ctrlDisabled: baseColors.ctrlDisabledHCLight,
    ctrlDisabledLabel: baseColors.ctrlDisabledLabelHCLight,
    ctrlHover: baseColors.ctrlHoverHCLight,
    footerBg: baseColors.footerBgHCLight,
    keyline: baseColors.keylineHCLight,
    label: baseColors.labelHCLight,
    labelCaption: baseColors.labelCaptionHCLight,
    labelPlaceholder: baseColors.labelPlaceholderHCLight,
    labelLegal: baseColors.labelLegalHCLight,
    navBg: baseColors.navBgHCLight,
    navLabel: baseColors.navLabelHCLight,
    navLabelDisabled: baseColors.navLabelDisabledHCLight,
    navLabelHover: baseColors.navLabelHoverHCLight,
    navLabelSelected: baseColors.navLabelSelectedHCLight,
    title: baseColors.titleHCLight,
    badInputBdr: baseColors.badInputBdrHCLight,
    badInputBg: baseColors.badInputBgHCLight,
    badInputLabel: baseColors.badInputLabelHCLight,
    error: baseColors.errorHCLight,
    errorHover: baseColors.errorHoverHCLight,
    errorBdr: baseColors.errorBdrHCLight,
    errorBg: baseColors.errorBgHCLight,
    info: baseColors.infoHCLight,
    infoHover: baseColors.infoHoverHCLight,
    infoBdr: baseColors.infoBdrHCLight,
    infoBg: baseColors.infoBgHCLight,
    success: baseColors.successHCLight,
    successHover: baseColors.successHoverHCLight,
    successBdr: baseColors.successBdrHCLight,
    successBg: baseColors.successBgHCLight,
    warning: baseColors.warningHCLight,
    warningHover: baseColors.warningHoverHCLight,
    warningBdr: baseColors.warningBdrHCLight,
    warningBg: baseColors.warningBgHCLight,
    clrBlue: baseColors.clrBlueHCLight,
    clrGreen: baseColors.clrGreenHCLight,
    clrOrange: baseColors.clrOrangeHCLight,
    clrPurple: baseColors.clrPurpleHCLight,
    clrTeal: baseColors.clrTealHCLight,
    clrGray: baseColors.clrGrayHCLight,
    clrIndigo: baseColors.clrIndigoHCLight,
    clrPink: baseColors.clrPinkHCLight,
    clrRed: baseColors.clrRedHCLight,
    clrYellow: baseColors.clrYellowHCLight,
    appleMusicRed: baseColors.appleMusicRedDark
  })
});